import { render, staticRenderFns } from "./ConfigurazioniAgendaPage.vue?vue&type=template&id=0fb57523"
import script from "./ConfigurazioniAgendaPage.vue?vue&type=script&lang=js"
export * from "./ConfigurazioniAgendaPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports